import { z } from 'zod'

export const COACHING_SHELL_ANALYTICS_CONTRACT_VERSION = '1.0.0' as const
export const coachingShellAnalyticsResponseSchema = z.unknown()
export type CoachingShellAnalyticsResponse = z.infer<typeof coachingShellAnalyticsResponseSchema>
